module.exports = __webpack_public_path__ + "img/nut-chestnuts-350x184.c58faa85.jpg";